import React, { useEffect, useState } from "react";
import { splitArrayToChunks } from "utility/helpers";
import { fetchPartylists } from "services/services.affiliation";
import styled from "styled-components";
import { Col } from "reactstrap";
import PartyContainer from "./PartyContainer";

const PartyParentContainer = styled(Col)`
  margin-top: 1.5rem;
  margin-bottom: 1.543m;
`;

const PartyListWrapper = styled.div`
  display: grid;
  justify-content: center;
  grid-template-columns: 400px 400px 400px;
  gap: 2rem;

  @media (max-width: 768px) {
    grid-template-columns: 250px 250px;
  }

  @media (max-width: 575px) {
    grid-template-columns: 200px;
  }

  @media (min-width: 768.98px) and (max-width: 1200px) {
    grid-template-columns: 300px 300px;
  }
`;

const PartyListContainer = styled.div`
  margin: 0;
  padding-left: 3rem;
  padding-right: 3rem;
`;

const PartyListHeader = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 50px;
  margin-bottom: 44px;
`;

const Main = () => {
  const [filteredData, setFilteredData] = useState([]);
  const [data, setData] = useState([]);

  const getFormattedData = () => {
    const newData = splitArrayToChunks(data, 3);
    let resultData = [];

    resultData =
      newData &&
      newData?.length &&
      newData?.length !== 0 &&
      newData.map((datum) => {
        return (
          datum?.length &&
          datum?.length !== 0 &&
          datum?.map((d) => {
            return {
              label: d?.name,
              link: `/parties/${d?.id}`,
              photo: d?.photo,
              id: d?.id,
            };
          })
        );
      });

    return resultData;
  };

  const fetchData = () => {
    fetchPartylists({
      callback: (Data) => {
        const newData = Data?.length !== 0 ? Data : [];

        setData(newData);
      },
    });
  };

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    if (data?.length !== 0) {
      const result = getFormattedData();
      setFilteredData(result);
    }
  }, [data]);

  return (
    <PartyListContainer>
      <PartyListHeader>
        <h1>{"Party Affiliation"}</h1>
      </PartyListHeader>

      <PartyListWrapper>
        {filteredData?.length !== 0 &&
          filteredData?.map((datum) => {
            return (
              <Col
                key={datum?.id}
                xs="auto"
              >
                {datum?.map((d) => {
                  return (
                    <PartyParentContainer key={d?.id}>
                      <PartyContainer
                        key={d?.id}
                        {...d}
                      />
                    </PartyParentContainer>
                  );
                })}
              </Col>
            );
          })}
      </PartyListWrapper>
    </PartyListContainer>
  );
};

export default Main;
